<script>
import Keycloak from 'keycloak-js';

export default {
  data() {
    return {
      lang: this.$store.state.config.selectedLanguage
    };
  },
  render: function(renderfunction) {
    return renderfunction();
  },
  computed: {
    keycloak() {
      return this.$store.state.keycloak;
    },
    userObject() {
      return this.$store.getters.userObject;
    }
  },
  async created() {
    const keycloak = Keycloak({
      url: 'https://api.dvgapp.org/auth/',
      realm: 'DVG',
      clientId: 'dvg-hoh-forms-dashboard'
      // scope: 'offline_access'
    });
    this.$store.commit('SET_KEYCLOAK', keycloak);

    //keycloak
    await this.checkForPreviousTokens();
    if (!this.$store.getters.authenticated) {
      this.loadWebKeycloak(this.$store.state.auth.accessToken, this.$store.state.auth.refreshToken);
    }
  },
  methods: {
    async checkForPreviousTokens() {
      const accessToken = localStorage.getItem('dvg-hoh-forms-dashboard-kc-token'); //offline_token
      const refreshToken = localStorage.getItem('dvg-hoh-forms-dashboard-kc-refresh-token'); //offline_token

      if (accessToken && refreshToken) {
        this.setAuthTokens(accessToken, refreshToken);
      }
    },
    async loadWebKeycloak(token, refresh) {
      this.$store.commit('SET_SHOW_LOADER', { action: true, text: this.$store.getters.content.one_moment[this.lang] + '...' });
      this.keycloak
        .init({
          onLoad: 'check-sso',
          checkLoginIframe: false,
          token: token,
          refreshToken: refresh
        })
        .then(auth => {
          if (auth) {
            this.$store.commit('SET_AUTHENTICATED', true);
            this.setupKeycloak(auth);
          } else {
            this.$store.commit('SET_AUTHENTICATED', false);
            this.clearToken();
          }
        })
        .catch(err => {
          console.log(err);
          this.clearToken();
        })
        .finally(() => {
          this.$store.commit('SET_SHOW_LOADER', { action: false });
        });
    },
    setupKeycloak() {
      if (this.keycloak.token != null && this.keycloak.refreshToken != null) {
        this.setAuthTokens(this.keycloak.token, this.keycloak.refreshToken);
      }

      this.keycloak
        .loadUserInfo()
        .then(data => {
          this.$store.commit('SET_USER_OBJECT', data);
        })
        .catch(err => {
          console.log(err);
          this.clearToken();
        });

      const loginUrl = this.keycloak.createLoginUrl();
      const logoutUrl = this.keycloak.createLogoutUrl({ redirectUri: window.location.origin });
      this.$store.commit('SET_LOGIN_URL', loginUrl);
      this.$store.commit('SET_LOGOUT_URL', logoutUrl);

      setInterval(() => {
        this.keycloak
          .updateToken(50)
          .then(refreshed => {
            if (refreshed) {
              console.log('Token refreshed: ' + refreshed);
              if (this.keycloak.token != null && this.keycloak.refreshToken != null) {
                this.setAuthTokens(this.keycloak.token, this.keycloak.refreshToken);
              }
            } else {
              if (this.keycloak.tokenParsed) {
                const exp = this.keycloak.tokenParsed.exp || 0;
                console.log('Token not refreshed, valid for ' + Math.round(exp - new Date().getTime() / 1000) + ' seconds');
              }
            }
          })
          .catch(() => {
            this.clearToken();
          });
      }, 6000);
    },
    clearToken() {
      localStorage.removeItem('dvg-hoh-forms-dashboard-kc-token');
      localStorage.removeItem('dvg-hoh-forms-dashboard-kc-refresh-token');
      this.$store.commit('SET_AUTH_TOKEN', null);
      this.$store.commit('SET_AUTH_REFRESH_TOKEN', null);
      this.$store.commit('SET_AUTHENTICATED', false);
    },
    setAuthTokens(token, refreshToken) {
      localStorage.setItem('dvg-hoh-forms-dashboard-kc-token', token); //offline_token
      localStorage.setItem('dvg-hoh-forms-dashboard-kc-refresh-token', refreshToken); //offline_token
      this.$store.commit('SET_AUTH_TOKEN', token);
      this.$store.commit('SET_AUTH_REFRESH_TOKEN', refreshToken);
    }
  }
};
</script>
